import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../assets/css/SignupNew.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    clientLogo1,
    clientLogo2,
    clientLogo3,
    clientLogo4,
    clientLogo5,
    clientLogo6,
} from "../../Constant";
import { RegisterAction } from "../../redux/actions/auth";

const SignUpNew = ({ auth, registerAction }) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [zip, setZip] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [hearAbout, setHearAbout] = useState("");

    const navigate = useNavigate();

    const register = async (e) => {
        e.preventDefault();
        if (password != confirmPassword) {
            return Swal.fire({
                title: "Validation",
                icon: "error",
                text: "Password doesn't match!",
            });
        }
        registerAction(
            firstName,
            lastName,
            email,
            password,
            confirmPassword,
            zip,
            hearAbout
        ).then(() => {});
    };

    useEffect(() => {
        if (auth.user && auth.token) {
            Swal.fire({
                text: "We have sent you a verification email; check your inbox. If you have not received the email, kindly check your spam folder it might have ended up there. Please note that the verification link will expire within one hour. ",
                title: "Verify Email",
                icon: "success",
            }).then(() => {
                if (auth.user && auth.token) {
                    navigate("/introduce");
                }
            });
        }
    }, [auth]);

    return (
        <>
            <Header />
            {/* <!-- Signup Box Start Here --> */}
            <section className="signup_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className="signup_box">
                                <div className="heading">
                                    <h5>
                                        <span className="light">Signup to</span>{" "}
                                        My Home Helper
                                    </h5>
                                </div>
                                <form
                                    onSubmit={register}
                                    id="register-form"
                                    className="form"
                                    action=""
                                    method="post"
                                >
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="fname">
                                                    First name *
                                                </label>
                                                <input
                                                    required
                                                    type="text"
                                                    id="first_name"
                                                    placeholder="First name"
                                                    className="form-control"
                                                    value={firstName}
                                                    onChange={(e) =>
                                                        setFirstName(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="lname">
                                                    Last name *
                                                </label>
                                                <input
                                                    required
                                                    type="text"
                                                    id="last_name"
                                                    placeholder="Last name"
                                                    className="form-control"
                                                    value={lastName}
                                                    onChange={(e) =>
                                                        setLastName(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="zip">
                                                    ZIP/postal/postcode *
                                                </label>
                                                <input
                                                    required
                                                    type="text"
                                                    id="zipCode"
                                                    className="form-control"
                                                    placeholder="Enter your ZIP/postal/postcode"
                                                    value={zip}
                                                    onChange={(e) =>
                                                        setZip(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="email">
                                                    Email *
                                                </label>
                                                <input
                                                    required
                                                    type="email"
                                                    id="create-email"
                                                    className="form-control"
                                                    placeholder="Enter your email"
                                                    value={email}
                                                    onChange={(e) =>
                                                        setEmail(e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="cpass">
                                                    Create password *
                                                </label>
                                                <input
                                                    required
                                                    type="password"
                                                    id="create-password"
                                                    className="form-control"
                                                    placeholder="Enter your new password"
                                                    value={password}
                                                    onChange={(e) =>
                                                        setPassword(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="confirmpass">
                                                    Confirm your password *
                                                </label>
                                                <input
                                                    required
                                                    type="password"
                                                    id="creat-confirm-password"
                                                    className="form-control"
                                                    placeholder="Confirm your password"
                                                    value={confirmPassword}
                                                    onChange={(e) =>
                                                        setConfirmPassword(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="hear_about">
                                                    How did you hear about us?
                                                    (Optional)
                                                </label>
                                                <input
                                                    id="hear_about"
                                                    type={"text"}
                                                    className="form-control"
                                                    placeholder="Hear About Us"
                                                    value={hearAbout}
                                                    onChange={(e) =>
                                                        setHearAbout(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="signup_withEmail">
                                        <input
                                            id="create-button"
                                            type="submit"
                                            name="create-button"
                                            className="logins_btn email-btn"
                                            value="Sign-Up"
                                        />
                                        {/* <!--                                                    <button className="logins_btn email-btn">Sign up</button>--> */}
                                    </div>
                                </form>

                                <div className="policyDv">
                                    <p>
                                        By signing in or signing up, I agree to
                                        myhomehelper.com's{" "}
                                        {/* <a href="#">
                                            Terms of Service
                                        </a> and  */}
                                        <Link to="/privacy-policy">
                                            Privacy Policy
                                        </Link>
                                        , confirm that I am 18 years of age or
                                        older, and consent to receiving email
                                        communication.
                                    </p>
                                </div>
                                <div className="have_account">
                                    <p>
                                        Already have an account?
                                        <Link to="/signin" className="ml-2">
                                            Sign in
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
            </section>
            {/* <!-- Signup Box End Here --> */}

            {/* <!-- Brands Div Start Here --> */}
            <section className="brandsDv">
                <div className="container">
                    <hr />
                    <div className="row">
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo1} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo2} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo3} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo4} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo5} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo6} alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </section>
            {/* <!-- Brands Div End Here --></div> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    registerAction: async (
        first_name,
        last_name,
        email,
        password,
        confirm_password,
        zip,
        hear_about
    ) =>
        dispatch(
            await RegisterAction(
                first_name,
                last_name,
                zip,
                email,
                password,
                confirm_password,
                hear_about
            )
        ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpNew);
